import { exportRowsToCsv } from "./dashboardsExport";
import type { RespiteNeedsAttentionRow } from "./respiteTypes";

export function respiteNeedsAttentionToCsvRows(
  rows: RespiteNeedsAttentionRow[],
): Array<Record<string, unknown>> {
  return rows.map((row) => ({
    Patient: row.patientName,
    Clinic: row.clinicName,
    "Care navigator": row.navigatorName,
    Provider: row.providerName,
    Service: row.serviceKind === "home_visit" ? "Home visit (HSA)" : "Respite",
    "Resource type": row.resourceType,
    "Engagement status": row.engagementStatus,
    "Referred on": row.referredOn,
    "Days open": row.daysOpen,
    "Guide state": row.guideState,
    "Respite eligible": row.respiteEligible ? "Yes" : "No",
    "Pylon status": row.pylonStatus ?? "",
    "Care plan on file": row.carePlanOnFile ? "Yes" : "No",
    "Care plan updated since referral": row.carePlanUpdatedSinceReferral ? "Yes" : "No",
    "Carespace URL": row.carespaceUrl,
  }));
}

export async function downloadRespiteNeedsAttentionCsv(
  rows: RespiteNeedsAttentionRow[],
  asOf: string,
): Promise<void> {
  if (!rows.length) return;
  await exportRowsToCsv(
    respiteNeedsAttentionToCsvRows(rows),
    `respite-needs-attention-${asOf}.csv`,
  );
}
